import "./App.css";
import logo from "./images/bitmovin-logo.png";
import BitmovinPlayer from "./bitmovinPlayer";

function App() {
  return (
    <div className="app">
      <div id="wrapper">
        <div id="banner">
          <div className="logo">
            <img src={logo} alt="" />
          </div>
          <div className="title">
            <h1>VOD DRM with static ads</h1>
          </div>
          <div className="clear" />
        </div>

        <div className="container">
          <ul>
            <li>5x Preroll: Lidl, Trevor Nelson, The 355, C4 Ident, Sponsor (Castillo de Ibiza)</li>
            <li>5x Midroll 00:10:25 - Trevor Nelson, The 355, Dairy Milk, Windows 11, Sun Princess</li>
          </ul>

          <div className="content">
            <div id="player-wrapper">
              <BitmovinPlayer />
              <div className="description">
                <p>
                  For more information about the bitmovin player, please have a
                  look at our online{" "}
                  <a
                    href="//bitmovin.com/support"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Developer Section
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
